import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { BasicTable } from "../UI/Table/BasicTable.tsx";
import { LessonInfo } from "./useGetUserLessonsInfo.ts";

const ALIGNED_RIGHT = { className: "text-right" };

const columnHelper = createColumnHelper<LessonInfo>();

const columns = [
  columnHelper.accessor("groupName", { header: "Group" }),
  columnHelper.accessor("isOneOnOne", {
    header: "Type",
    cell: (info) =>
      info.getValue() ? (
        <span
          className={
            "px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800"
          }
        >
          1 on 1
        </span>
      ) : (
        <span
          className={
            "px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800"
          }
        >
          Group
        </span>
      ),
  }),
  columnHelper.accessor("lessonCount", {
    header: "Lessons",
    meta: ALIGNED_RIGHT,
  }),
  columnHelper.accessor("noShowCount", {
    header: "No shows",
    meta: ALIGNED_RIGHT,
  }),
  columnHelper.accessor("totalFeedbackReceived", {
    header: "Feedbacks",
    meta: ALIGNED_RIGHT,
  }),
];

export function UserLessonsInfoTable({
  lessonsInfo,
}: {
  lessonsInfo: LessonInfo[];
}) {
  const table = useReactTable({
    columns,
    data: lessonsInfo,
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <BasicTable
      table={table}
      compact
      scrollableMinWidthClassName={"min-w-[480px]"}
    />
  );
}
